<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> {{ data.icon }} </span>
      <p>{{ data.textIcon }}</p>
    </div>
    <span class="material-icons float-end CloseModal" mat-dialog-close>
      close
    </span>
  </div>

  <div class="align-items-center justify-content-center box-contrato">
    <div class="loader"  *ngIf="!data.pdf"><img _ngcontent-wgy-c162="" width="40" height="40" src="../../../assets/svg/icon-spinner.svg"></div>
    <pdf-viewer [src]="data.pdf" *ngIf="data.pdf"  style="width:  100%; height: 500px; max-height: 75vh;" [original-size]="false" [show-all]="true" [autoresize]="true" [fit-to-page]="true"  ></pdf-viewer>
  </div>

  <div class="row">
    <div class="col text-center">
      <div class="mt-24 mb-24 pt-16 pb-16">
        <a class="text-underline" *ngIf="this.contracts.linkContratoSafari" [href]="this.contracts.linkContratoSafari" download="ContratoSabemiDigital.pdf">
          <span class="material-icons align-middle me-10">file_download</span>
          Baixar o contrato
        </a>
        <a *ngIf="!this.contracts.linkContratoSafari" (click)="this.contracts.download()">
          <span class="material-icons align-middle me-10">file_download</span>
          Baixar o contrato
        </a>
      </div>
    </div>
  </div>

</div>